export const userProfile = {
  updateEmailForm: {
    newEmailAddress: {
      label: 'New email address',
      placeholder: 'Enter email',
    },
    confirmNewEmailAddress: {
      label: 'Confirm new email address',
      placeholder: 'Enter email',
    },
    enterValidEmail: 'Please enter a valid email.',
    bothEmailMustMatch: 'Both emails must match',
    password: {
      label: 'Password',
      placeholder: 'Enter password',
    },
    pleaseInputPassword: 'Please provide the password',
    emailUpdateSuccess: 'Success. Please log in with {{ newUid }}',
  },
  register: {
    confirmPassword: {
      action: 'Confirm password',
      label: 'Confirm password',
      placeholder: 'Confirm Password',
    },
    managementInMyAccount: 'Management in My Account.',
    termsAndConditions: 'Terms and Conditions',
    signIn: 'I already have an account. Sign in',
    register: 'Register',
    confirmNewPassword: 'Confirm New Password',
    resetPassword: 'Reset Password',
    createAccount: 'Create an account',
    title: 'Title',
    titleOptional: 'Title (optional)',
    firstName: {
      label: 'First name',
      placeholder: 'First name',
    },
    lastName: {
      label: 'Last name',
      placeholder: 'Last name',
    },
    emailAddress: {
      label: 'Email address',
      placeholder: 'Email address',
    },
    password: {
      label: 'Password',
      placeholder: 'Password',
    },
    newPassword: 'New Password',
    emailMarketing:
      'Use my personal data to receive email newsletters for marketing campaigns. To change your settings, go to Consent Management in My Account.',
    confirmThatRead: 'I confirm that I have read and agree to the',
    selectTitle: 'Select Title',
    passwordMinRequirements:
      'Here is a quick guide for a secure password: must have 8 to 16 characters, including at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character.',
    bothPasswordMustMatch: 'Both passwords must match',
    titleRequired: 'Title is required.',
    postRegisterMessage: 'Please log in with the provided credentials.',
		requestCreatedSuccessfully: 'Thank you for your submission. Your request is being processed.',
		accountNotFound: 'Account not found!',
    emailVerify: {
      USER_REGISTERED: 'Your account already exist, please request access to additional accounts through your profile section',
      USER_PENDING_APPROVAL: 'There is a pending request for this email. Please reach out to your company admin or contact our experts for assistance.',
    },
  },
  forgottenPassword: {
    resetPassword: 'Reset password',
    enterEmailAddressAssociatedWithYourAccount: 'Enter the email address associated with your account',
    emailAddress: {
      label: 'Email address',
      placeholder: 'Enter your email',
    },
    enterValidEmail: 'Please enter a valid email.',
    passwordResetEmailSent:
      'If the email address provided belongs to a registered user, we will send you instructions for changing your password via email.',
    passwordResetSuccess: 'Password changed successfully.',
  },
  updateProfile: {
    assignedRoles: 'Assigned Roles',
    linkedAccounts: 'Linked Accounts',
    accNumber: 'Account Number',
    accName: 'Account Name',
    adminName: "Administrator's Name",
    adminEmail: "Administrator's Email",
    requestRole: 'Change Permission',
    requestRoleTitleModal: 'Request Role',
  },
};
